export { Quote, type QuoteProps } from "./Quote";
